// config.ts
import { Config } from "@adornis/config/config.js";
var versionedEntityConfig = new Config("versioned-entity-config", {
  authorCollectionName: {
    client: false,
    defaultVal: "adornisuser",
    env: true,
    name: "AUTHOR_COLLECTION_NAME",
    required: false
  }
});
export {
  versionedEntityConfig
};
